import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

function Registered() {
  const { t } = useTranslation('translations');
  
  return (
    <Fragment>
      <header>
        <h1>{t('Everything done!')}</h1>
      </header>
      <main>
        <section>
          <p>{t('You are now successfully logged in.')}</p>
        </section>
      </main>
    </Fragment>
  );
}

export default Registered;
